import { render, staticRenderFns } from "./ClubPi.vue?vue&type=template&id=63b792fc&scoped=true&"
import script from "./ClubPi.vue?vue&type=script&lang=js&"
export * from "./ClubPi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b792fc",
  null
  
)

export default component.exports